export default "__VITE_ASSET__CdwVm8r8__"